import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// PricingPage now redirects to the unified Billing & Subscription page
export default function PricingPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/manager/billing', { replace: true });
  }, [navigate]);
  return null;
}
